export const TTB_PAGE_LIST = [
  { value: 'ttb_bank', text: 'TTB Bank' },
  { value: 'ttb_drive', text: 'TTB Drive' }
]

export const TTB_CHANNEL_LIST = [
  { value: 'facebook', text: 'Facebook' },
  // { value: 'line', text: 'LINE' },
  { value: 'x', text: 'X' },
  { value: 'pantip', text: 'Pantip' }
]

export const TTB_WRAP_UP = [
  {
    level_1: 'Retail ttb',
    level_2: [
      {
        title: 'Complaint',
        level_3: [
          {
            title: 'Auto Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Branch/Office/Building/Machine',
            level_4: [
              { title: 'สาขามีน้อย' },
              { title: 'ตู้อัตโนมัติมีน้อย (ATM ADM PUM)' },
              { title: 'อื่นๆ (ที่จอดรถน้อย,ความสะอาด,ลิฟท์ ฯลฯ)' }
            ]
          },
          {
            title: 'Credit Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Deposit/Debit/PromptPay',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'โปรโมชัน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Home Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Personal Loan/Flash Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'touch/internet banking',
            level_4: [
              { title: 'ปัญหาค้าง ช้า ทำรายการไม่ได้ เข้าไม่ได้' },
              { title: 'ดาวน์โหลด/อัปเดต/สมัคร ไม่ได้' },
              { title: 'หน้าตา/สีสัน/เมนู/การออกแบบ/ใช้งานยาก' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Other Product/Other Service',
            level_4: [{ title: 'อื่นๆ' }]
          },
          {
            title: 'Staff/Service',
            level_4: [
              { title: 'ติดต่อ Contact Center ไม่ได้ / ถือสายรอนาน' },
              { title: 'เจ้าหน้าที่ Inbound Voice/NV' },
              { title: 'เจ้าหน้าที่ Outbound/Tele Sales' },
              { title: 'เจ้าหน้าที่ สาขา' },
              { title: 'เจ้าหน้าที่ สำนักงานใหญ่' },
              { title: 'เจ้าหน้าที่ ติดตามการชำระ (ตามหนี้)' },
              { title: 'เจ้าหน้าที่ อื่นๆ (รปภ แม่บ้าน เมสเซนเจอร์ ฯลฯ)' }
            ]
          },
          {
            title: 'Welfare (สินเชื่อสวัสดิการ)',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Feedback',
        level_3: [
          {
            title: 'Auto Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Branch/Office/Building/Machine',
            level_4: [
              { title: 'สาขามีน้อย' },
              { title: 'ตู้อัตโนมัติมีน้อย (ATM ADM PUM)' },
              { title: 'อื่นๆ (ที่จอดรถน้อย,ความสะอาด,ลิฟท์ ฯลฯ)' }
            ]
          },
          {
            title: 'Credit Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Deposit/Debit/PromptPay',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'โปรโมชัน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Home Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Personal Loan/Flash Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'touch/internet banking',
            level_4: [
              { title: 'ปัญหาค้าง ช้า ทำรายการไม่ได้ เข้าไม่ได้' },
              { title: 'ดาวน์โหลด/อัปเดต/สมัคร ไม่ได้' },
              { title: 'หน้าตา/สีสัน/เมนู/การออกแบบ/ใช้งานยาก' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Other Product/Other Service',
            level_4: [{ title: 'อื่นๆ' }]
          },
          {
            title: 'Staff/Service',
            level_4: [
              { title: 'ติดต่อ Contact Center ไม่ได้ / ถือสายรอนาน' },
              { title: 'เจ้าหน้าที่ Inbound Voice/NV' },
              { title: 'เจ้าหน้าที่ Outbound/Tele Sales' },
              { title: 'เจ้าหน้าที่ สาขา' },
              { title: 'เจ้าหน้าที่ สำนักงานใหญ่' },
              { title: 'เจ้าหน้าที่ ติดตามการชำระ (ตามหนี้)' },
              { title: 'เจ้าหน้าที่ อื่นๆ (รปภ แม่บ้าน เมสเซนเจอร์ ฯลฯ)' }
            ]
          },
          {
            title: 'Welfare (สินเชื่อสวัสดิการ)',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Complement (ชม)',
        level_3: [
          {
            title: 'Auto Loan',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ สินเชื่อรถยนต์' }]
          },
          {
            title: 'Branch/Office/Building/Machine',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ ตัวอาคารสถานที่ต่างๆ/ตู้อัตโนมัติต่างๆ' }]
          },
          {
            title: 'Credit Card',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ บัตรเครดิต' }]
          },
          {
            title: 'Deposit/Debit/PromptPay',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ บัญชี บัตรเดบิต พร้อมเพย์' }]
          },
          {
            title: 'Home Loan',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ สินเชื่อบ้าน' }]
          },
          {
            title: 'Personal Loan/Flash Card',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ สินเชื่อส่วนบุคคล บัตรกดเงินสด' }]
          },
          {
            title: 'touch/internet banking',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ Online Banking' }]
          },
          {
            title: 'Other Product/Other Service',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ อื่นๆ' }]
          },
          {
            title: 'Staff/Service',
            level_4: [{ title: 'ชมเชย ตัวพนักงาน การบริการ' }]
          },
          {
            title: 'Welfare (สินเชื่อสวัสดิการ)',
            level_4: [{ title: 'ชมเชยผลิตภัณฑ์ สินเชื่อสวัสดิการ' }]
          }
        ]
      },
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'Auto Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'สอบถาม/ลงทะเบียน มาตรการแผ่นดินไหว' },
              { title: 'ติดตามผล มาตรการแผนดินไหว' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'สติกเกอร์' },
              { title: 'มาตรการช่วยเหลือโครงการBOT/โครงการภาครัฐ/โครงการของธนาคาร' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Branch/Office/Building/Machine',
            level_4: [
              { title: 'สาขา (ที่ตั้ง เบอร์โทร เวลาทำการ ฯลฯ)' },
              { title: 'ตู้อัตโนมัติมีน้อย (ATM ADM PUM)' },
              { title: 'อื่นๆ (อาคารสำนักงานอื่นๆ)' }
            ]
          },
          {
            title: 'Credit Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'สอบถาม/ลงทะเบียน มาตรการแผ่นดินไหว' },
              { title: 'ติดตามผล มาตรการแผนดินไหว' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'สติกเกอร์' },
              { title: 'มาตรการช่วยเหลือโครงการBOT/โครงการภาครัฐ/โครงการของธนาคาร' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Deposit/Debit/PromptPay',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'โปรโมชัน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Home Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'สอบถาม/ลงทะเบียน มาตรการแผ่นดินไหว' },
              { title: 'ติดตามผล มาตรการแผนดินไหว' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'สติกเกอร์' },
              { title: 'มาตรการช่วยเหลือโครงการBOT/โครงการภาครัฐ/โครงการของธนาคาร' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Personal Loan/Flash Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'สอบถาม/ลงทะเบียน มาตรการแผ่นดินไหว' },
              { title: 'ติดตามผล มาตรการแผนดินไหว' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'สติกเกอร์' },
              { title: 'มาตรการช่วยเหลือโครงการBOT/โครงการภาครัฐ/โครงการของธนาคาร' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'touch/internet banking',
            level_4: [
              { title: 'การสมัคร' },
              { title: 'การใช้งาน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Other Product/Other Service',
            level_4: [
              { title: 'สอบถามโครงการช่วยเหลือลูกหนี้ "คุณสู้ เราช่วย"' },
              { title: 'โครงการคุณสู้ เราช่วย_สอบถามรายละเอียดโครงการและวิธีการลงทะเบียน' },
              { title: 'โครงการคุณสู้ เราช่วย_ติดปัญหาการลงทะเบียนไม่ได้ แนะนำการลงทะเบียน' },
              { title: 'โครงการคุณสู้ เราช่วย_ติดตามสถานะการลงทะเบียน (ไม่เกิน SLA 10 วันทำการ)' },
              { title: 'สอบถาม/ลงทะเบียน มาตรการแผ่นดินไหว' },
              { title: 'ติดตามผล มาตรการแผนดินไหว' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'สติกเกอร์' },
              { title: 'Festival/Event' },
              { title: 'มาตรการช่วยเหลือโครงการBOT/โครงการภาครัฐ/โครงการของธนาคาร' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Staff/Service',
            level_4: [
              { title: 'พนักงานคนนี้/เบอร์นี้ เป็นของธนาคารหรือไม่' },
              { title: 'ธนาคารมีการทำแบบนี้หรือไม่ (โทรขายประกัน,โทรขายผลิตภัณฑ์ ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Incident/Crisis/Event',
            level_4: [
              { title: 'ข่าวที่ออก' },
              { title: 'touch/internet banking ขัดข้อง-มีปัญหา' },
              { title: 'บัตรเครดิตมีปัญหา/ใช้งานไม่ได้' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Welfare (สินเชื่อสวัสดิการ)',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Request',
        level_3: [
          {
            title: 'Auto Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Branch/Office/Building/Machine',
            level_4: [
              { title: 'สาขา (ที่ตั้ง เบอร์โทร เวลาทำการ ฯลฯ)' },
              { title: 'ตู้อัตโนมัติมีน้อย (ATM ADM PUM)' },
              { title: 'อื่นๆ (อาคารสำนักงานอื่นๆ)' }
            ]
          },
          {
            title: 'Credit Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Deposit/Debit/PromptPay',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'โปรโมชัน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Home Loan',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Personal Loan/Flash Card',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'touch/internet banking',
            level_4: [
              { title: 'การสมัคร' },
              { title: 'การใช้งาน' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Other Product/Other Service',
            level_4: [
              { title: 'สอบถามโครงการช่วยเหลือลูกหนี้ "คุณสู้ เราช่วย"' },
              { title: 'โครงการคุณสู้ เราช่วย_สอบถามรายละเอียดโครงการและวิธีการลงทะเบียน' },
              { title: 'โครงการคุณสู้ เราช่วย_ติดปัญหาการลงทะเบียนไม่ได้ แนะนำการลงทะเบียน' },
              { title: 'โครงการคุณสู้ เราช่วย_ติดตามสถานะการลงทะเบียน (ไม่เกิน SLA 10 วันทำการ)' },
              { title: 'สอบถามโปรแกรม "ผ่อนดี..มีรางวัล"' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Staff/Service',
            level_4: [
              { title: 'พนักงานคนนี้/เบอร์นี้ เป็นของธนาคารหรือไม่' },
              { title: 'ธนาคารมีการทำแบบนี้หรือไม่ (โทรขายประกัน,โทรขายผลิตภัณฑ์ ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Incident/Crisis/Event',
            level_4: [
              { title: 'ข่าวที่ออก' },
              { title: 'touch/internet banking ขัดข้อง-มีปัญหา' },
              { title: 'บัตรเครดิตมีปัญหา/ใช้งานไม่ได้' },
              { title: 'อื่นๆ' }
            ]
          },
          {
            title: 'Welfare (สินเชื่อสวัสดิการ)',
            level_4: [
              { title: 'นโยบาย/เงื่อนไขของผลิตภัณฑ์' },
              { title: 'ค่าธรรมเนียมต่างๆ' },
              { title: 'การติดตาม/ทวงหนี้' },
              { title: 'โปรโมชัน' },
              { title: 'ช่องทางการชำระ/เงื่อนไขการชำระ' },
              { title: 'การสมัคร/การอนุมัติ' },
              { title: 'ข้อมูลส่วนบุคคล (ชื่อ เบอร์ ที่อยู่ อีเมล ฯลฯ)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Other',
        level_3: [
          {
            title: 'Reject case',
            level_4: [{ title: 'ไม่เกี่ยวข้อง' }, { title: 'อื่นๆ' }]
          }
        ]
      }
    ]
  },
  {
    level_1: 'ttb advisory',
    level_2: [
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'Mutual Fund (กองทุน)',
            level_4: [
              { title: 'ข้อมูลผลิตภัณฑ์/โปรโมชัน' },
              { title: 'สอบถาม / เงื่อนไข / ตรวจสอบข้อมูลกองทุน TAX' },
              { title: 'สอบถามรายการ Point to Invest' },
              { title: 'สอบถามข้อมูลกองทุนผ่าน ttb touch' },
              { title: 'ติดตามธุรกรรมกองทุน' },
              { title: 'สอบถามเอกสารกองทุน' },
              { title: 'ติดต่อเจ้าหน้าที่กองทุน' }
            ]
          }
        ]
      }
    ]
  },
  {
    level_1: 'ttb sme jurestic',
    level_2: [
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'สินเชื่อ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'รีไฟแนนซ์',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'บัญชีเพื่อธุรกิจภายในประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ธุรกรรมภายในประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'บัญชีเพื่อธุรกรรมต่างประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ธุรกรรมระหว่างประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ttb business one ดิจิทัล แบงก์กิ้ง',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ประกันสินเชื่อ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ค้ำประกัน',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          }
        ]
      },
      {
        title: 'Complaint',
        level_3: [
          {
            title: 'ttb business one ดิจิทัล แบงก์กิ้ง',
            level_4: [
              { title: 'แจ้งปัญหาการใช้งาน' },
              { title: 'บัญชีไม่สามารถใช้งาน (โดนล็อค)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Feedback',
        level_3: [
          {
            title: 'ttb business one ดิจิทัล แบงก์กิ้ง',
            level_4: [
              { title: 'แจ้งปัญหาการใช้งาน' },
              { title: 'บัญชีไม่สามารถใช้งาน (โดนล็อค)' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      }
    ]
  },
  {
    level_1: 'Finbiz',
    level_2: [
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'ความรู้ทางการเงิน',
            level_4: [{ title: 'อื่นๆ' }, { title: 'ชมเชยอื่นๆ' }]
          }
        ]
      },
      {
        title: 'Complement (ชม)',
        level_3: [
          {
            title: 'ความรู้ทางการเงิน',
            level_4: [{ title: 'อื่นๆ' }, { title: 'ชมเชยอื่นๆ' }]
          }
        ]
      }
    ]
  },
  {
    level_1: 'corp ttb',
    level_2: [
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'สินเชื่อ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'บัญชีและธุรกรรมภายในประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'บัญชีและธุรกรรมระหว่างประเทศ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          },
          {
            title: 'ดิจิทัล แบงก์กิ้งและบริการอื่น ๆ',
            level_4: [{ title: 'ข้อมูลผลิตภัณฑ์' }, { title: 'อื่นๆ' }]
          }
        ]
      },
      {
        title: 'Complaint',
        level_3: [
          {
            title: 'ดิจิทัล แบงก์กิ้งและบริการอื่น ๆ',
            level_4: [{ title: 'แจ้งปัญหาการใช้งาน' }, { title: 'อื่นๆ' }]
          }
        ]
      },
      {
        title: 'Feedback',
        level_3: [
          {
            title: 'ดิจิทัล แบงก์กิ้งและบริการอื่น ๆ',
            level_4: [{ title: 'แจ้งปัญหาการใช้งาน' }, { title: 'อื่นๆ' }]
          }
        ]
      }
    ]
  },
  {
    level_1: 'Punboon',
    level_2: [
      {
        title: 'Inquiry',
        level_3: [
          {
            title: 'บริจาคเงินออนไลน์',
            level_4: [
              { title: 'ปันบุญ คืออะไร' },
              { title: 'วิธีบริจาคเงินออนไลน์ผ่านปันบุญ' },
              { title: 'เริ่มบริจาคเงินออนไลน์ ให้มูลนิธิและองค์กรสาธารณกุศล' },
              { title: 'บริจาคเงินออนไลน์ลดหย่อนภาษี 2 เท่า' },
              { title: 'อื่นๆ' }
            ]
          }
        ]
      },
      {
        title: 'Complaint',
        level_3: [
          {
            title: 'บริจาคเงินออนไลน์',
            level_4: [{ title: 'แจ้งปัญหาการใช้งาน' }, { title: 'อื่นๆ' }]
          }
        ]
      },
      {
        title: 'Feedback',
        level_3: [
          {
            title: 'บริจาคเงินออนไลน์',
            level_4: [{ title: 'แจ้งปัญหาการใช้งาน' }, { title: 'อื่นๆ' }]
          }
        ]
      },
      {
        title: 'Complement (ชม)',
        level_3: [
          {
            title: 'บริจาคเงินออนไลน์',
            level_4: [{ title: 'ชมเชยอื่นๆ' }]
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/constants/ttb.js